var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"select-input"},[_vm._t("default"),_c('span',{staticClass:"select-input-label"},[_c('mark-icon',{attrs:{"size":"17"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }